<template>
    <section id="registerDiv">
        <div class="container">
            <!-- Jumbotron -->
            <div class="px-4 py-5 px-md-5 text-center text-lg-start loginContain">
                <div class="container">
                    <div class="row gx-lg-5 align-items-center">
                        <div class="col-lg-6 mb-5 mb-lg-0">
                            <h1 class="my-5 display-3 fw-bold ls-tight">
                                The best offer <br />
                                <span class="text-primary">for your business</span>
                            </h1>
                            <p style="color: hsl(217, 10%, 50.8%)">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                Eveniet, itaque accusantium odio, soluta, corrupti aliquam
                                quibusdam tempora at cupiditate quis eum maiores libero
                                veritatis? Dicta facilis sint aliquid ipsum atque?
                            </p>
                        </div>

                        <div class="col-lg-6 mb-5 mb-lg-0">
                            <div class="card">
                                <div class="card-body py-5 px-md-5" id="loginBox">
                                    <div class="row">
                                        <div class="col-12" id="box">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <label for="businessName" class="control-label"></label>
                                                    <input type="text" class="col-12 inputText form-control borderR"
                                                        placeholder="Business Name *" id="businessName"
                                                        name="businessName" required />
                                                    <small class="text-danger" id="businessNameError"></small>
                                                </div>

                                                <div class="col-md-12">
                                                    <label for="businessNumber" class="control-label"></label>
                                                    <input type="text" class="col-12 inputText form-control borderR"
                                                        placeholder="Business Number *" id="businessNumber"
                                                        name="businessNumber" required />
                                                    <small class="text-danger" id="businessNumberError"></small>
                                                </div>

                                                <div class="col-md-12">
                                                    <label for="businessMobile" class="control-label"></label>
                                                    <input type="text" class="col-12 inputText form-control borderR"
                                                        placeholder="Business Contact No *" id="businessMobile"
                                                        name="businessMobile" required />
                                                    <small class="text-danger" id="businessMobileError"></small>
                                                </div>

                                                <div class="col-md-12">
                                                    <label for="businessMail" class="control-label"></label>
                                                    <input type="email" class="col-12 inputText form-control borderR"
                                                        placeholder="Business Contact Email *" id="businessMail"
                                                        name="businessMail" required />
                                                    <small class="text-danger" id="businessMailError"></small>
                                                </div>

                                                <div class="col-md-12">
                                                    <label for="businessAddress" class="control-label"></label>
                                                    <textarea class="col-12 inputText form-control borderR"
                                                        placeholder="Business Address *" id="businessAddress"
                                                        name="businessAddress" required></textarea>
                                                    <small class="text-danger" id="businessAddressError"></small>
                                                </div>

                                                <div class="col-md-12">
                                                    <div class="mb-3">
                                                        <label class="control-label mt-3">Upload Business Proofs</label>
                                                        <input class="col-12 inputText form-control borderR" type="file"
                                                            id="businessFile" multiple>
                                                        <small class="text-danger" id="businessFileError"></small>
                                                    </div>
                                                </div>

                                                <div class="col-md-12">
                                                    <div class="mb-3">
                                                        <label class="control-label mt-3">Upload User Verification
                                                            Proofs (NIC / Passport)</label>
                                                        <input class="col-12 inputText form-control borderR" type="file"
                                                            id="userFile" multiple>
                                                        <small class="text-danger" id="userFileError"></small>
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="button" class="col-12 btn btn-info mt-4" id="saveRegBtn">
                                                Save
                                            </button>
                                        </div>
                                        <div class="alert alert-success" role="alert" id="successMsg">
                                            <h4 class="alert-heading">Well done!</h4>
                                            <p>Your business details have been successfully added, and your account is
                                                also verified. Once our staff reviews and approves your business
                                                profile, you will gain full access. Until then, you can continue using
                                                the platform as a basic user.</p>
                                            <hr>
                                            <p class="mb-0">Thank you for choosing us!</p>
                                        </div>
                                        <button type="button" class="col-4 btn btn-info" id="successBtn">
                                            Go to Home
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Section: Design Block -->
            </div>
        </div>
    </section>
</template>

<script>
import $ from 'jquery';

export default {
    name: 'businessReg',
    mounted() {
        this.initializeEventListeners();   // Fetch data when component is mounted
    },
    methods: {
        saveCustomer() {
            const businessNumber = $('#businessNumber').val();
            const businessName = $('#businessName').val();
            const businessMobile = $('#businessMobile').val();
            const businessMail = $('#businessMail').val();
            const businessAddress = $('#businessAddress').val();

            const urlParams = new URLSearchParams(window.location.search);
            const email = urlParams.get('email');

            console.log(email); // Log the email for debugging

            $.ajax({
                url: process.env.VUE_APP_API_URL + '/saveBusinessDetails',
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') // Add CSRF token
                },
                data: {
                    businessNumber,
                    businessName,
                    businessMobile,
                    businessMail,
                    businessAddress,
                    email
                },
                beforeSend: () => {
                    // Show the loading screen before sending the request
                    $('#loadingScreen').removeClass('d-none');
                },
                success: (response) => {
                    console.log(response); // Log response for debugging
                    $('#loadingScreen').addClass('d-none');
                    $('#box').hide();
                    $('#saveRegBtn').hide();
                    $('#successMsg').show();
                    $('#successBtn').show();
                },
                error: (xhr, status, error) => {
                    $('#loadingScreen').addClass('d-none'); // Hide loading screen on error
                    console.log('Error:', error); // Log error for debugging

                    // Handle error response
                    if (xhr.status === 422) {
                        // Extract validation errors
                        const errors = xhr.responseJSON.errors;
                        let errorMessages = '';

                        // Concatenate error messages
                        $.each(errors, (key, messages) => {
                            errorMessages += messages.join('\n') + '\n'; // Join messages with a newline
                        });

                        // Display error messages
                        alert('Validation errors:\n' + errorMessages); // Alert for validation errors
                        // Optionally, display errors next to the corresponding input fields
                        $.each(errors, (key, messages) => {
                            $(`#${key}Error`).text(messages.join(', ')); // Show error next to field
                        });
                    } else {
                        // Fallback to general error message
                        let errorMessage = 'An error occurred. Please try again.';
                        if (xhr.responseJSON && xhr.responseJSON.message) {
                            errorMessage = xhr.responseJSON.message;
                        } else if (xhr.responseText) {
                            errorMessage = xhr.responseText;
                        }
                        // alert(errorMessage); // Show error alert
                    }
                }
            });
        }
        ,

        initializeEventListeners() {
            const self = this;

            $('#saveRegBtn').click(function () {
                let valid = true;
                $('#box small.text-danger').text(''); // Clear previous error messages

                $('#registerDiv input, #registerDiv textarea').each(function () {
                    const id = $(this).attr('id');
                    const fieldLabel = $(this).attr('placeholder') || $(this).find('option:selected').text();

                    if ($(this).val() === '') {
                        valid = false;
                        $(`#${id}Error`).text(`${fieldLabel.replace(' *', '')} is required.`);
                    }
                });

                // File validation
                const fileInput = $('#businessFile');
                if (fileInput[0].files.length === 0) {
                    valid = false;
                    $('#businessFileError').text('File is required.');
                }

                // File validation
                const userInput = $('#userFile');
                if (userInput[0].files.length === 0) {
                    valid = false;
                    $('#userFileError').text('File is required.');
                }

                if (!valid) {
                    console.log('Validation failed.'); // Debugging log
                    return; // Stop if any validation fails
                } else {
                    console.log('Validation successful. Calling saveCustomer...'); // Debugging log
                    self.saveCustomer(); // Proceed to save customer details
                }
            });

            $('#successBtn').click(function () {
                window.location.href = '/'; // Redirect to home page
            });
        }

    }
}
</script>

<style scoped>
#successMsg {
    display: none;
    /* Initially hide successMsg */
}

#successBtn {
    display: none;
    /* Initially hide successBtn */
}

/* Add any additional styling you need */
</style>
